export default {
  tourData: {
    fallback: {
      included: ['Paseo incluido', 'Atención local', 'Experiencia exclusiva en Paraty'],
      notIncluded: ['Comidas y bebidas', 'Traslado desde el hotel'],
      bringItems: ['Protector solar', 'Ropa ligera', 'Agua', 'Cámara'],
      meetingPoint: 'Paraty, RJ',
      startTime: 'Por confirmar',
      maxGroupSize: 'Grupo',
      cancellation: 'Consulta la política de cancelación del paseo.',
      privacyPolicy: 'Política de privacidad disponible en el sitio web.',
      importantNotes: ['Confirma el horario con el equipo antes del paseo.'],
      genericTag: 'Paseo en barco',
    },
  },
};
